var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Wrapper',[_c('h1',{staticClass:"text-center mb-3"},[_vm._v(_vm._s(_vm.$t('header', { name: _vm.userName })))]),_c('p',{staticClass:"text-center mb-4"},[_vm._v(_vm._s(_vm.$t('description')))]),_c('h3',{staticClass:"text-center mb-5"},[_vm._v(_vm._s(_vm.$t('subheader')))]),_c('FeatureColumns',{attrs:{"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }